import React from 'react';
import styled from 'styled-components';

import { useTranslation } from 'context/translations';
import RehabState, { RehabStateApiName } from 'models/RehabState';
import { Label } from 'styles/typography';
import DischargedEmptyState from 'svg/DischargedEmptyState';
import InTreatmentEmptyState from 'svg/InTreatmentEmptyState';
import QueueEmptyState from 'svg/QueueEmptyState';

const LANE_ATTRS = {
  [RehabStateApiName.Queue]: QueueEmptyState,
  [RehabStateApiName.InTreatment]: InTreatmentEmptyState,
  [RehabStateApiName.Discharged]: DischargedEmptyState,
};

interface LaneEmptyStateProps {
  rehabState: RehabState;
}

function LaneEmptyState({ rehabState }: LaneEmptyStateProps) {
  const Component = LANE_ATTRS[rehabState.apiName];
  const { translate } = useTranslation();

  return (
    <Container>
      {Component && <Component />}
      <StateLabel>No patients in {translate(rehabState.state)}</StateLabel>
    </Container>
  );
}

export default LaneEmptyState;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
`;

const StateLabel = styled(Label)`
  color: ${({ theme }) => theme.colors.black50};
  margin-top: 14px;
`;
